/**
 * Keeps visible category label in sync with the search category <select>.
 * Search forms always GET global /search; option values are collection handles
 * (or empty for "All categories"). Selected category is mirrored in the URL as
 * ?search_category={handle} via a hidden input (disabled when "All").
 */
(function () {
  var PARAM = 'search_category';

  function labelForSelect(select) {
    var opt = select.options[select.selectedIndex];
    return opt ? opt.textContent.trim() : '';
  }

  function getGlobalSearchAction() {
    if (typeof window !== 'undefined' && window.routes && window.routes.search_url) {
      return window.routes.search_url;
    }
    return '/search';
  }

  function syncFormActionFromCategory(select) {
    var form = select.form;
    if (!form) return;
    form.setAttribute('action', getGlobalSearchAction());
  }

  function syncSearchCategoryHidden(select) {
    var form = select.form;
    if (!form) return;
    var hidden = form.querySelector('.header-search__category-param');
    if (!hidden) return;
    if (select.selectedIndex <= 0 || !select.value) {
      hidden.setAttribute('disabled', 'disabled');
      hidden.value = '';
    } else {
      hidden.removeAttribute('disabled');
      hidden.value = select.value;
    }
  }

  function bindFormSubmitSync(form) {
    if (!form || form.dataset.headerSearchSubmitActionBound === 'true') return;
    form.dataset.headerSearchSubmitActionBound = 'true';
    form.addEventListener('submit', function () {
      form.setAttribute('action', getGlobalSearchAction());
    });
  }

  function shouldSkipHydrateFromUrl() {
    if (
      document.querySelector(
        'main-search[data-search-category-mismatch], main-search[data-search-empty-products]'
      )
    ) {
      return true;
    }
    try {
      var st = window.__SEARCH_CATEGORY_STATE__;
      if (st && st.skipHydrateFromUrl === true) {
        return true;
      }
    } catch (e) {
      /* ignore */
    }
    return false;
  }

  function hydrateCategoryFromUrl() {
    try {
      if (shouldSkipHydrateFromUrl()) {
        return;
      }
      var params = new URLSearchParams(window.location.search);
      var cat = params.get(PARAM);
      if (!cat) return;
      document.querySelectorAll('.header-search__category').forEach(function (select) {
        for (var i = 0; i < select.options.length; i++) {
          if (select.options[i].value === cat) {
            select.selectedIndex = i;
            break;
          }
        }
      });
    } catch (e) {
      /* ignore */
    }
  }

  function sync() {
    document.querySelectorAll('.header-search__category').forEach(function (select) {
      syncFormActionFromCategory(select);
      syncSearchCategoryHidden(select);
      var wrap = select.closest('.header-search__category-wrap');
      if (wrap) {
        var out = wrap.querySelector('[data-selected-category-label]');
        if (out) {
          out.textContent = labelForSelect(select);
        }
        var prefix = select.getAttribute('data-category-aria-prefix') || 'Category';
        select.setAttribute('aria-label', prefix + ': ' + labelForSelect(select));
      }
      if (select.form) bindFormSubmitSync(select.form);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    hydrateCategoryFromUrl();
    sync();
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('.header-search__category')) {
      sync();
      var form = e.target.form;
      if (form) {
        var predictive = form.closest('predictive-search');
        if (predictive && typeof predictive.onCategoryChanged === 'function') {
          predictive.onCategoryChanged();
        }
      }
    }
  });
  document.addEventListener('shopify:section:load', sync);
})();
